
import React from 'react';
import SignUp from '../components/Auth/SignUp';
import Footer from '../components/Common/Footer';

const SignUpPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SignUp />
      
    </div>
  );
};

export default SignUpPage;